const FIRST_X_POS = 0
const FIRST_Y_POS = 0

export const getPictureBorderSize = (size) => {
  return size >= 100 ? 4 : 3
}

export const getLeftPos = ({index, total, wrapperSize, multiplePictureSize, horizontal}) => {
  if (horizontal) {
    return FIRST_X_POS + index * (multiplePictureSize / 2)
  }
  const lastXPos = wrapperSize - (multiplePictureSize + getPictureBorderSize(multiplePictureSize) * 2)
  const gapSize = lastXPos / (total - 1)

  return FIRST_X_POS + index * gapSize
}

export const getTopPos = ({index, total, wrapperSize, multiplePictureSize}) => {
  const lastYPos = wrapperSize - (multiplePictureSize + getPictureBorderSize(multiplePictureSize) * 2)
  const gapSize = lastYPos / (total - 1)

  return FIRST_Y_POS + index * gapSize
}

export const calculateInnerWrapperSize = (outerWrapperSize, innerWrapperSize, total) => {
  let size = total <= 2 ? innerWrapperSize : innerWrapperSize + 10 * total

  if (size > outerWrapperSize) {
    size = outerWrapperSize
  }

  return size
}
